(function () {
    angular.module('ui2.0Service').factory('externalContactService', ['$rootScope', '$timeout', 'showPage2DataTransformationService',
        function ($rootScope, $timeout, showPage2DataTransformationService) {

            function applySelectedSupplierToExternalContactData($scope, data) {
                if (!$rootScope.externalContract || !data || !data.body || !data.body.data) {
                    return;
                }
                const payload = $scope.dataOfUserRoleGroup;
                if (!payload) {
                    return;
                }

                let selectedSupplier = payload.selectedSupplier;
                if (!selectedSupplier || !selectedSupplier.id) {
                    const apiUrl = payload.jspApi || payload.api || $scope.jsonUrl || '';
                    const supplierIdMatch = apiUrl.match(/\/externalcontact\/new\/(\d+)/);
                    if (supplierIdMatch) {
                        const supplierId = Number(supplierIdMatch[1]);
                        const suppliers = payload.suppliers
                            || (payload.stakeholdersFieldData && payload.stakeholdersFieldData.createFlowSuppliers)
                            || [];
                        selectedSupplier = _.find(suppliers, function (s) {
                            return String(s.id) === String(supplierId);
                        }) || { id: supplierId };
                    }
                }

                if (!selectedSupplier || !selectedSupplier.id) {
                    return;
                }

                if (!data.body.data.supplier) {
                    data.body.data.supplier = { name: 'supplier' };
                }

                const existingValues = _.get(data.body.data, 'supplier.values') || {};
                if (!existingValues.id || !existingValues.name) {
                    data.body.data.supplier.values = {
                        id: selectedSupplier.id,
                        name: selectedSupplier.name || selectedSupplier.shortName || selectedSupplier.displayName || existingValues.name || String(selectedSupplier.id),
                        shortName: selectedSupplier.shortName,
                        url: existingValues.url || ('/tblrelations/show/' + selectedSupplier.id),
                    };
                }
            }

            function isCreateLikePageType(pageType) {
                return ['create', 'clone', 'globalCreate'].indexOf(pageType) > -1;
            }

            function isCdrCreateExternalContactFlow($scope) {
                // Sticky flag survives cancel races where scope flags were already cleared.
                if (window.__ecCdrCreateFlowActive) {
                    return true;
                }
                if (!$scope.openFromUserRoleGroup) {
                    return false;
                }
                return !!(
                    $scope.openExternalContactFromCdrCreate ||
                    ($rootScope.externalContract && isCreateLikePageType($scope.pageType)) ||
                    _.get($scope, 'dataOfUserRoleGroup.isCreateFlow') ||
                    _.get($scope, 'dataOfUserRoleGroup.stakeholdersFieldData.isCreateFlow')
                );
            }

            function forceDestroyExternalContactPopup($scope) {
                // showinpopup2 only re-links when ng-if flips false -> true.
                if ($scope.header && $scope.header.response) {
                    $scope.header.response.type = 'basic';
                }
                $scope.jsonUrl = null;
                if (!$scope.$$phase) {
                    $scope.$applyAsync();
                }
            }

            function cleanupExternalContactSupplierSelectModal() {
                delete window.__pendingExternalContactSupplierSelect;
                try {
                    window.sarc.channelBroadcast('externalContactSupplierSelectModal', {
                        actionType: 'closeModal',
                        payload: null,
                    }, 'externalContactSupplierSelectSubscription');
                } catch (e) {}
                try {
                    document.querySelectorAll('.ec_supplier_select_overlay, .ec_supplier_select_modal').forEach(function (node) {
                        if (node && node.parentNode) {
                            node.parentNode.removeChild(node);
                        }
                    });
                } catch (e) {}
                try {
                    const ecSupplierMountEl = document.getElementById('externalContactSupplierSelectModal');
                    if (ecSupplierMountEl && window.reactComponents) {
                        window.reactComponents.unmountDynamicComponent(ecSupplierMountEl);
                    }
                } catch (e) {}
            }

            function closeExternalContactAngularModal($scope, ownedByCancel) {
                if (ownedByCancel) {
                    // Window flag is durable across restore vs closed.then race.
                    $scope._ecModalCloseOwnedByCancel = true;
                    window.__ecOwnedModalClose = true;
                }
                const modal = $rootScope.myModelInstance;
                $rootScope.myModelInstance = null;
                if ($rootScope.modalInstances) {
                    $rootScope.modalInstances = [];
                }
                if ($scope.modalInstances) {
                    $scope.modalInstances = [];
                }
                if (modal) {
                    try {
                        modal.close();
                    } catch (e) {}
                }
                try {
                    const ecModals = angular.element('.modal.create_external_contact_popup, .create_external_contact_popup').closest('.modal');
                    if (ecModals.length) {
                        ecModals.remove();
                        if (!angular.element('.modal:visible').length) {
                            angular.element('.modal-backdrop').remove();
                            angular.element('body').removeClass('modal-open');
                        }
                    }
                } catch (e) {}
            }

            function restoreCreatePageActions($scope) {
                // Re-sync actions so Create stays Create after EC popup restore.
                if ($scope.pageType) {
                    $rootScope.pageType = $scope.pageType;
                }
                if ($scope.globalData) {
                    $scope.globalData.pageType = $scope.pageType;
                }
                const layoutActions = _.get($scope, 'myJson.layoutInfo.actions')
                    || _.get($scope, 'layoutInfo.actions')
                    || $scope.actions;
                if (layoutActions && layoutActions.length) {
                    $scope.actions = angular.copy(layoutActions);
                    $scope.cActions = angular.copy(layoutActions);
                    if ($scope.pageType && $scope.pageType !== 'show') {
                        showPage2DataTransformationService.separateButtons.call($scope, $scope.actions);
                    }
                }
                if ($scope.cActions && $scope.globalData && $scope.globalData.dynamicFormId) {
                    try {
                        window.sarc.channelBroadcast("reactDynamicForms", {
                            actionType: "updateAdditionalData",
                            payload: window.createRDFSecObj($scope)
                        }, 'dfSubscriptions_' + $scope.globalData.dynamicFormId);
                    } catch (e) {}
                }
            }

            function restoreCdrCreateAfterExternalContact($scope, deps, preserveNewContactSelection) {
                window.__ecButtonClickLockUntil = 0;
                delete $rootScope.externalContract;
                $scope.fromExternalUser = false;
                $scope.isSkipNotification = true;
                delete $scope.isNewEntityCreate;
                // Keep new-contact props through remount so stakeholder field can auto-select.
                if (!preserveNewContactSelection) {
                    $scope.dataOfnewExtarnalContract = null;
                    $scope.dataOfUserRoleGroup = null;
                    $scope.openFromUserRoleGroup = false;
                }
                $scope.openExternalContactFromCdrCreate = false;
                $scope.stakeHolderBBDetails = {};
                $scope.dynamicPageTitle = '';
                if (deps && deps.setIsCreate) {
                    deps.setIsCreate(false);
                }
                if (deps && deps.prepareEcRestore) {
                    deps.prepareEcRestore();
                }
                $scope.fromExternalUserOld = false;
                stopLoader();

                $scope.applyBasePageJson();
                forceDestroyExternalContactPopup($scope);
                restoreCreatePageActions($scope);

                if (deps && deps.resetPopupScopes) {
                    deps.resetPopupScopes();
                }
                // Ownership flags are cleared in closed.then (or fallback timeout below).

                if (!$scope.$$phase) {
                    $scope.$applyAsync();
                }
                $timeout(function () {
                    restoreCreatePageActions($scope);
                    if ($scope.globalData && $scope.globalData.dynamicFormId) {
                        window.sarc.channelBroadcast("reactDynamicForms", {
                            actionType: "saveFormUiState",
                            payload: { type: 'applyPatch' }
                        }, 'dfSubscriptions_' + $scope.globalData.dynamicFormId);
                    }
                    if (preserveNewContactSelection) {
                        $scope.dataOfnewExtarnalContract = null;
                        $scope.dataOfUserRoleGroup = null;
                        $scope.openFromUserRoleGroup = false;
                    }
                }, 150);
                $timeout(function () {
                    delete window.__ecCdrCreateFlowActive;
                    delete window.__ecOwnedModalClose;
                    $scope._ecModalCloseOwnedByCancel = false;
                }, 1000);
            }

            function openCdrCreateExternalContactModal($scope, payload, deps) {
                window.__ecButtonClickLockUntil = 0;
                delete window.__ecOwnedModalClose;
                $scope._ecModalCloseOwnedByCancel = false;
                cleanupExternalContactSupplierSelectModal();
                forceDestroyExternalContactPopup($scope);
                closeExternalContactAngularModal($scope, false);

                $rootScope.externalContract = true;
                $scope.fromExternalUser = true;
                var isCreateLikePage = isCreateLikePageType($scope.pageType);
                $scope.openExternalContactFromCdrCreate = !!(
                    payload.isCreateFlow ||
                    (payload.stakeholdersFieldData && payload.stakeholdersFieldData.isCreateFlow) ||
                    (payload.fromType === 'RoleGroup' && isCreateLikePage)
                );
                if ($scope.openExternalContactFromCdrCreate) {
                    window.__ecCdrCreateFlowActive = true;
                }
                if (payload.fromType === 'RoleGroup') {
                    $scope.dataOfUserRoleGroup = payload;
                    $scope.openFromUserRoleGroup = true;
                } else {
                    $scope.dataOfShareCountyPartyModal = payload;
                    $scope.openFromShareWithConuterParty = true;
                }
                $scope.stakeHolderBBDetails = {
                    topBBId: payload.topBBId,
                    fieldId: payload.fieldId,
                };

                if (deps && deps.ensurePopupScopesForClone) {
                    deps.ensurePopupScopesForClone();
                }
                if (!$scope.cActions && $scope.actions && $scope.actions.length) {
                    $scope.cActions = angular.copy($scope.actions);
                }

                $timeout(function () {
                    $scope.plusIconReq(payload.jspApi || payload.api, "Create External Contact", payload, null, null, payload);
                }, 50);
            }

            function handleCdrCreateExternalContactCancel($scope, deps) {
                window.doNotRedirectToPreviousRoute = true;
                window.doNotApplyOldScope = true;
                closeExternalContactAngularModal($scope, true);
                $timeout(function () {
                    restoreCdrCreateAfterExternalContact($scope, deps);
                }, 0);
            }

            function handleCdrCreateExternalContactSuccess($scope, deps) {
                if (_.get($scope, 'dataOfnewExtarnalContract') && _.get($scope, 'responseDataFromPopup.header.response.entityId')) {
                    $scope.dataOfnewExtarnalContract.id = $scope.responseDataFromPopup.header.response.entityId;
                }
                window.doNotRedirectToPreviousRoute = true;
                window.doNotApplyOldScope = true;

                const stakeHolderBBDetails = $scope.stakeHolderBBDetails;
                const newContact = $scope.dataOfnewExtarnalContract;

                closeExternalContactAngularModal($scope, true);

                Toaster.create(intl_msg[34983] || "Contact added successfully");

                const hasNewContact = !!(newContact && newContact.id);

                $timeout(function () {
                    restoreCdrCreateAfterExternalContact($scope, deps, hasNewContact);
                    if ($scope.globalData && $scope.globalData.dynamicFormId) {
                        if (hasNewContact) {
                            try {
                                $scope.dataOfnewExtarnalContract = newContact;
                                window.sarc.channelBroadcast("reactDynamicForms", {
                                    actionType: "updateAdditionalData",
                                    payload: window.createRDFSecObj($scope)
                                }, 'dfSubscriptions_' + $scope.globalData.dynamicFormId);
                            } catch (error) {
                                console.error("Error broadcasting external contact update:", error);
                            }
                        }
                        window.sarc.channelBroadcast("reactDynamicForms", {
                            actionType: "newlyCreatedExternalContactDetails",
                            payload: stakeHolderBBDetails
                        }, 'dfSubscriptions_' + $scope.globalData.dynamicFormId);
                    }
                }, 0);
            }

            function openExternalContactSupplierSelect(payload) {
                const mountAt = '#externalContactSupplierSelectModal';
                const mountEl = document.getElementById('externalContactSupplierSelectModal');
                window.__ecButtonClickLockUntil = 0;
                window.__pendingExternalContactSupplierSelect = payload;

                try {
                    document.querySelectorAll('.ec_supplier_select_overlay, .ec_supplier_select_modal').forEach(function (node) {
                        if (node && node.parentNode) {
                            node.parentNode.removeChild(node);
                        }
                    });
                } catch (e) {}

                const doMount = function () {
                    window.reactComponents.mountDynamicComponent(mountAt, 'ExternalContactSupplierSelectModal', {});
                    $timeout(function () {
                        window.sarc.channelBroadcast('externalContactSupplierSelectModal', {
                            actionType: 'openModal',
                            payload: payload,
                        }, 'externalContactSupplierSelectSubscription');
                    }, 50);
                };

                if (mountEl && window.reactComponents) {
                    try {
                        window.reactComponents.unmountDynamicComponent(mountEl);
                    } catch (e) {}
                    $timeout(doMount, 0);
                } else {
                    doMount();
                }
            }

            function attachToScope($scope, deps) {
                $scope.applySelectedSupplierToExternalContactData = function (data) {
                    applySelectedSupplierToExternalContactData($scope, data);
                };
                $scope.isCdrCreateExternalContactFlow = function () {
                    return isCdrCreateExternalContactFlow($scope);
                };
                $scope.openCdrCreateExternalContactModal = function (payload) {
                    openCdrCreateExternalContactModal($scope, payload, deps);
                };
                $scope.handleCdrCreateExternalContactCancel = function () {
                    handleCdrCreateExternalContactCancel($scope, deps);
                };
                $scope.handleCdrCreateExternalContactSuccess = function () {
                    handleCdrCreateExternalContactSuccess($scope, deps);
                };
            }

            return {
                attachToScope: attachToScope,
                openExternalContactSupplierSelect: openExternalContactSupplierSelect,
            };
        }
    ]);
})();
